import React from "react";

export const SelectorContext = React.createContext();
